import { initCarousel } from '@/braun/Controllers/BraunCarouselController';
import intPdpCompareController from '@/utils/Controllers/PdpCompareController';

const updateComparedItems = swiper => {
  const currEl = swiper.slides[swiper.activeIndex];
  if (currEl) {
    const { comparedProductCode } = currEl.dataset;
    Array.from(document.querySelectorAll('.js-compared-product-code')).forEach(
      item => {
        item.hidden = item.dataset.comparedProductCode !== comparedProductCode;
      },
    );
  }
};

const initCompareProducts = async el => {
  const { slidesNumber } = el.dataset;
  if (slidesNumber && slidesNumber <= 1) return;
  const swiper = await initCarousel(
    el,
    {
      slidesPerViewXl: 1,
      slidesPerViewL: 1,
      slidesPerViewM: 1,
      slidesPerViewXs: 1,

      spaceBetweenXl: 20,
      spaceBetweenL: 20,
      spaceBetweenM: 20,
      spaceBetweenXs: 10,

      hideScrollbar: false,
    },
    {
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      loop: true,
      roundLengths: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    },
  );
  swiper.on('slideChange', () => updateComparedItems(swiper));
};

const jsEventsCallback = () => {
  const compareProductsSliders = document.querySelectorAll(
    '.bra-compare-product__slides',
  );
  setTimeout(() => {
    Array.from(compareProductsSliders).forEach(item =>
      initCompareProducts(item),
    );
  }, 5000);
};

export default () => {
  intPdpCompareController(jsEventsCallback);
};
